import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

export const styles = StyleSheet.create({
	container: {
		minHeight: '100vh',
		backgroundColor: THEME.colors.background.main,
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '100vh',
	},
	errorContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '100vh',
		padding: `0 ${THEME.spacing.md}px`,
	},
	errorContent: {
		textAlign: 'center',
		maxWidth: 600,
	},
	errorTitle: {
		fontSize: THEME.typography.fontSizes.xxl,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.md,
		[THEME.queries.md]: {
			fontSize: THEME.typography.fontSizes.xl,
		},
	},
	errorMessage: {
		fontSize: THEME.typography.fontSizes.lg,
		color: THEME.colors.text.light,
		lineHeight: 1.6,
		[THEME.queries.md]: {
			fontSize: THEME.typography.fontSizes.md,
		},
	},
	eventsSection: {
		padding: `${THEME.spacing.xxl}px 0`,
		backgroundColor: THEME.colors.background.light,
		[THEME.queries.md]: {
			padding: `${THEME.spacing.lg}px 0`,
		},
	},
	tabList: {
		maxWidth: THEME.breakpoints.xl,
		boxSizing: 'border-box',
		margin: `0 auto ${THEME.spacing.xl}px auto`,
		padding: `0 ${THEME.spacing.md}px`,
		[THEME.queries.md]: {
			padding: '0 12px',
			marginBottom: THEME.spacing.lg,
		},
	},
	eventsGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
		gap: THEME.spacing.md,
		padding: `0 ${THEME.spacing.md}px`,
		maxWidth: THEME.breakpoints.xl,
		boxSizing: 'border-box',
		margin: '0 auto',
		[THEME.queries.md]: {
			gridTemplateColumns: '1fr',
			padding: '0 12px',
		},
	},
	pastEventsHeading: {
		fontSize: 28,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		textAlign: 'left',
		margin: `${THEME.spacing.xxxl}px 0 ${THEME.spacing.lg}px 0`,
		padding: `0 ${THEME.spacing.md}px`,
		maxWidth: THEME.breakpoints.xl,
		boxSizing: 'border-box',
		marginLeft: 'auto',
		marginRight: 'auto',
		[THEME.queries.md]: {
			fontSize: THEME.typography.fontSizes.xl,
			margin: `${THEME.spacing.xl}px 0 ${THEME.spacing.md}px 0`,
		},
	},
	noCurrentEventsMessage: {
		textAlign: 'center',
		padding: `${THEME.spacing.lg}px ${THEME.spacing.md}px`,
		maxWidth: THEME.breakpoints.xl,
		boxSizing: 'border-box',
		margin: '0 auto',
		fontSize: THEME.typography.fontSizes.lg,
		color: THEME.colors.text.light,
		[THEME.queries.md]: {
			fontSize: THEME.typography.fontSizes.md,
			padding: `${THEME.spacing.md}px 12px`,
		},
	},
});
